import { render, staticRenderFns } from "./EstimateServiceCost copy 2.vue?vue&type=template&id=631af37e&scoped=true&"
import script from "./EstimateServiceCost copy 2.vue?vue&type=script&lang=js&"
export * from "./EstimateServiceCost copy 2.vue?vue&type=script&lang=js&"
import style0 from "./EstimateServiceCost copy 2.vue?vue&type=style&index=0&id=631af37e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631af37e",
  null
  
)

export default component.exports